(function() {
'use strict';

angular
    .module('core')
    .directive('pauseCall', pauseCall);

function pauseCall($rootScope, agentModeService, resourceService, broker) {
    return {
        restrict: 'A',
        link: _linker
    };

    function _linker(scope, element) {
        const structure = _createStructure();

        element.on('focus', 'input, select', _pollingStatus);

        broker.subscribe('pauseCallDirective', 'pciFrameFocus', _pollingStatus);

        const extensions = $rootScope.agent ? $rootScope.agent.PhoneNumbers : [];

        scope.$on('$destroy', function() {
            $(structure.action).off('click');
            broker.unsubscribe('pauseCallDirective');
        });

        function _pollingStatus() {
            _bringInFocus(element);
            _bringInFocus($('#payment-details'));

            agentModeService
                .checkExtensionStatus(extensions)
                .then(function existActiveExtension(exists) {
                    if (exists) {
                        structure.overlay.style.display = 'block';
                        _addMessages({ messageText: resourceService.get('CPTRYPAUSE') });
                        _tryToPause();
                    } else {
                        _hideOverlay();
                    }
                });
        }

        function _tryToPause() {
            agentModeService
                .pauseCall()
                .then(
                    function _successfullyPaused() {
                        _addMessages({
                            messageText: resourceService.get('CPSUCCESSPAUSE'),
                            actionText: resourceService.get('CPRESUME'),
                            actionHandler: _tryToResume
                        });
                    },
                    function _pauseFailed(errorString) {
                        if (errorString === 'ABORT') {
                            _hideOverlay();
                            return;
                        }

                        _addMessages(
                        {
                            messageText: `${resourceService.get('CPFAILPAUSE')} ${errorString}`,
                            actionText: resourceService.get('CPTRYAGAIN'),
                            actionHandler: _tryToPause
                        },
                        {
                            messageText: resourceService.get('CPOR')
                        },
                        {
                            actionText: resourceService.get('CPCONTINUEUNPAUSED'),
                            actionHandler: _forceContinue('Pause')

                        });
                    }
                );
        }

        function _tryToResume() {
            agentModeService
                .resumeCall()
                .then(
                    function _successfullyResumed() {
                        _addMessages({
                            messageText: resourceService.get('CPSUCCESSRESUME'),
                            actionText: resourceService.get('CPHIDE'),
                            actionHandler: _hideOverlay
                        });
                    },
                    function _resumeFailed(errorString) {
                        if (errorString === 'ABORT') {
                            _hideOverlay();
                            return;
                        }

                        _addMessages(
                        {
                            messageText: `${resourceService.get('CPFAILRESUME')} ${errorString}`,
                            actionText: resourceService.get('CPTRYAGAIN'),
                            actionHandler: _tryToResume
                        },
                        {
                            messageText: resourceService.get('CPOR')
                        },
                        {
                            actionText: resourceService.get('CPCONTINUE'),
                            actionHandler: _forceContinue('Resume')

                        });
                    }
                );
        }

        function _forceContinue(type) {
            return function() {
                agentModeService.logFatalError(type);
                _hideOverlay();
            };
        }

        function _bringInFocus(el) {
            el.css('z-index', 4200);
            el.css('position', 'relative');
        }

        function _hideOverlay() {
            structure.container.style.display = 'none';
            structure.overlay.style.display = 'none';

            element.css('z-index', 0);
            $('#payment-details').css('z-index', 0);
        }

        function _addMessages(...args) {
            while (structure.container.lastChild) {
                structure.container.removeChild(structure.container.lastChild);
            }

            for (let i = 0, ii = args.length; i < ii; i++) {
                const curr = args[i];

                const message = document.createElement('span');
                message.textContent += i > 0 ? ' ' : '';
                message.textContent += curr.messageText ? `${curr.messageText} ` : '';
                structure.container.appendChild(message);

                const action = document.createElement('span');
                action.className = 'pause-resume-action';
                action.textContent = curr.actionText || '';
                action.onclick = curr.actionHandler || undefined;
                structure.container.appendChild(action);
            }
            structure.container.style.display = 'block';
        }

        function _createStructure() {
            const overlay = document.createElement('div');
            overlay.className = 'pause-resume-overlay';
            document.body.appendChild(overlay);

            const messageContainer = document.createElement('div');
            messageContainer.className = 'agent-panel';
            messageContainer.style.display = 'none';
            element[0].appendChild(messageContainer);

            return {
                overlay,
                container: messageContainer
            };
        }
    }
}
})();
